import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceORG {
    lookupService = new APIServiceLookUp();

    async createOrg(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}org/createOrg`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateOrg(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}org/updateOrg`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAllOrgs(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}org/getAllOrgs`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getOrgById(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}org/getOrgById`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getSubLicById(body, orgid) {
        var serviceType = "CUST";
        var url = `${API_URL}org/getSubLicById`;
        var apiService = this.lookupService.getAPIService(serviceType);
        var requestHeaders = {
            'Content-type': 'application/json',
            'Accept': 'application/json',
            'x-org-id': orgid,
        };
        return await apiService.doCall(url, body, requestHeaders);
    }
}